<template>

  <div class="page">
    <div class="main">
      <!-- 頁面抬頭-->
      <section class="title-cover">
        <!-- 頁面標題-->
        <picture class="title-img"> <img src="../assets/awardTW/img/title.png"></picture>
      </section>
      <section class="awards awards-1st">
        <picture class="title-img"><img src="../assets/awardTW/img/no1.png"></picture>
        <ul class="awards-list">
          <li> <span class="name">陳先生</span><span class="number">*******413</span></li>
        </ul>
        <picture class="awards-img"><img src="../assets/awardTW/img/no1-CAR.png"><img style="margin: -5% auto -6%;z-index: -1;" src="../assets/awardTW/img/bg-fifa.png"></picture>
      </section>
      <!-- 影片區-->
      <section class="video-cover">
        <picture class="title-img"><img src="../assets/awardTW/img/video-title.png"></picture>
        <div class="video-box"><iframe id="odysee-iframe" width="560" height="315"
          src="https://odysee.com/$/embed/特斯拉中文:9?r=wSexF3ohosVzk5VPEFEoJRbYmzEojK5n" allowfullscreen></iframe></div>
      </section>
      <section class="awards-cover">
        <!-- 2等獎-->
        <section class="awards awards-2st">
          <picture class="title-img"><img src="../assets/awardTW/img/no2.png"></picture>
          <ul class="awards-list">
            <li> <span class="name">王先生</span><span class="number">*******810</span></li>
            <li> <span class="name">葉小姐</span><span class="number">*******845</span></li>
            <li> <span class="name">高先生</span><span class="number">*******956</span></li>
          </ul>
        </section>
        <!-- 3等獎-->
        <section class="awards awards-3st">
          <picture class="title-img"><img src="../assets/awardTW/img/no3.png"></picture>
          <ul class="awards-list">
            <li> <span class="name">李先生</span><span class="number">*******354</span></li>
            <li> <span class="name">白先生</span><span class="number">*******636</span></li>
            <li> <span class="name">黃先生</span><span class="number">*******895</span></li>
            <li> <span class="name">林先生</span><span class="number">*******732</span></li>
            <li> <span class="name">賴先生</span><span class="number">*******223</span></li>
            <li> <span class="name">董先生</span><span class="number">*******359</span></li>
          </ul>
        </section>
        <!-- 4等獎-->
        <section class="awards awards-4st">
          <picture class="title-img"><img src="../assets/awardTW/img/no4.png"></picture>
          <ul class="awards-list">
            <li> <span class="name">蕭先生</span><span class="number">*******468</span></li>
            <li> <span class="name">葉先生</span><span class="number">*******093</span></li>
            <li> <span class="name">何先生</span><span class="number">*******788</span></li>
            <li> <span class="name">楊先生</span><span class="number">*******620</span></li>
            <li> <span class="name">游小姐</span><span class="number">*******531</span></li>
            <li> <span class="name">王先生</span><span class="number">*******294</span></li>
            <li> <span class="name">廖先生</span><span class="number">*******609</span></li>
            <li> <span class="name">張先生</span><span class="number">*******347</span></li>
          </ul>
        </section>
        <!-- 5等獎-->
        <section class="awards awards-5st">
          <picture class="title-img"><img src="../assets/awardTW/img/no5.png"></picture>
          <ul class="awards-list">
            <li> <span class="name">江先生</span><span class="number">*******938</span></li>
            <li> <span class="name">魏先生</span><span class="number">*******702</span></li>
            <li> <span class="name">蔡先生</span><span class="number">*******213</span></li>
            <li> <span class="name">康先生</span><span class="number">*******159</span></li>
            <li> <span class="name">廖先生</span><span class="number">*******098</span></li>
            <li> <span class="name">陳先生</span><span class="number">*******067</span></li>
            <li> <span class="name">劉先生</span><span class="number">*******194</span></li>
            <li> <span class="name">邱先生</span><span class="number">*******950</span></li>
          </ul>
        </section>
      </section>
    <!-- 廠商-->
      <ul class="manufacturers-list">
        <li><img src="../assets/awardTW/img/logo-OB.png"></li>
        <li><img src="../assets/awardTW/img/logo-BWIN.png"></li>
        <li><img src="../assets/awardTW/img/logo-DBG.png"></li>
        <li><img src="../assets/awardTW/img/logo-QT.png"></li>
        <li><img src="../assets/awardTW/img/logo-GR.png"></li>
        <li><img src="../assets/awardTW/img/logo-BNG.png"></li>
        <li><img src="../assets/awardTW/img/logo-SA.png"></li>
      </ul>
    </div>
  <article class="btn-box"> <a class="btn btn-goHome" a href="https://www.gm1788.net"><img src="../assets/awardTW/img/icon-goHome.svg"></a></article>
  </div>
</template>

<script>
export default {

  data() {
    return {

    };
  },
}
</script>


<style scoped>
@import '../assets/awardTW/css/style.css';
</style>



// WEBPACK FOOTER //
// src/components/award1688.vue